/**
 * The bundle entry point.
 *
 * One import with a side effect: registering `<betting-widget>`. Everything
 * else is exported from `index.ts`, which is importable from a test or a server
 * without touching a browser global.
 *
 *   <script type="module" src="geni-widget.js"></script>
 *   <betting-widget api-base="…" publishable-key="pk_…"></betting-widget>
 */
import { registerBettingWidget } from './custom-element.js';

registerBettingWidget();

export * from './index.js';
